import {Button, Divider, Grid, Stack, Typography} from "@mui/material"
import {useTranslation} from "react-i18next";
import {useFacebookConfig} from "crqlar-react-common/dist/utils/hooks/meta/useFacebookConfig";
import {LoginSocialFacebook} from "reactjs-social-login";
import ChangeAdAccountDialog from "../../marketing/meta/ChangeAdAccountDialog";
import React, {useState} from "react";
import {useQueryClient} from "react-query";
import {AdAccount} from "crqlar-react-common/dist/models/meta/adAccount";
import {FacebookConfig} from "crqlar-react-common/dist/models/meta/facebookConfig";
import {FacebookService} from "crqlar-react-common/dist/services/meta/facebook.service";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";

interface Props {
    setNavigateDirectlyToAdAccount: (value: boolean) => void
}

const AdAccountDetails = (props: Props) => {

    const [changeAdAccountDialogOpen, setChangeAdAccountDialogOpen] = useState(false)
    const facebookConfig = useFacebookConfig()
    const {t} = useTranslation()
    // Read-only users may view the connected ad account, but not change or disconnect it.
    const readOnly = useReadOnly()
    const queryClient = useQueryClient()

    const handleConfirmChangeAdAccount = (selectedAdAccount: AdAccount | undefined) => {
        setChangeAdAccountDialogOpen(false)
        const newConfig: FacebookConfig = {
            ...facebookConfig,
            adAccountId: selectedAdAccount?.id as string
        };
        FacebookService.saveConfig(newConfig).then((response) => {
            queryClient.invalidateQueries(['facebookConfig']);
        });
    }

    const handleDisconnect = () => {
        FacebookService.disconnect().then(() => {
            queryClient.invalidateQueries(['facebookConfig']);
            props.setNavigateDirectlyToAdAccount(true)
        });
    }

    const handleSuccessAuthorize = (response: any) => {
        console.log('Disconnected - no authorization')
    };

    return(
        <Stack gap={4} p={4} width={'100%'}>
            <Stack direction={'column'} gap={4}>

                <Stack direction={'row'} gap={4}>

                    <Grid item>
                        <Typography variant="h4" gutterBottom>
                            {t('Current Ad Account')}:
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="h5" sx={{fontWeight: 'bold'}}>
                            {facebookConfig?.adAccountName ? facebookConfig.adAccountName : '---'}
                        </Typography>
                        <Typography>
                            {facebookConfig?.adAccountId}
                        </Typography>
                    </Grid>

                </Stack>

                <Divider/>

                <Stack direction={'row'} gap={8}>

                    <Grid item>
                        <Button
                            variant="contained"
                            disabled={readOnly}
                            onClick={() => setChangeAdAccountDialogOpen(true)}
                        >
                            {t('Change Ad Account')}
                        </Button>
                    </Grid>

                    <Grid item>
                        <LoginSocialFacebook
                            appId={facebookConfig?.appId as string}
                            scope="ads_management,business_management"
                            onResolve={handleSuccessAuthorize}
                            onLogoutSuccess={handleDisconnect}
                            onReject={(error: any) => {
                                console.log(error)
                            }}
                        >
                            <Button
                                id={"fb-logout-btn"}
                                variant="outlined"
                                disabled={readOnly}
                                onClick={handleDisconnect}
                            >
                                {t('Disconnect')}
                            </Button>
                        </LoginSocialFacebook>
                    </Grid>

                </Stack>

            </Stack>

            <ChangeAdAccountDialog
                open={changeAdAccountDialogOpen}
                onClose={() => {
                    setChangeAdAccountDialogOpen(false)
                }}
                onConfirm={(selectedAdAccount) => handleConfirmChangeAdAccount(selectedAdAccount)}
                facebookConfig={facebookConfig}
            />
        </Stack>
    )
}

export default AdAccountDetails
